// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"323f77ac","262":"35a3df79","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};